module.exports = __webpack_public_path__ + "fonts/AmazonEmberDisplay_Rg.woff2";